import { partition } from 'lodash';
import { IMaterializedReference } from './materializeReferencePath';

export type IPartitionedReferences = [
  contextRefs: IMaterializedReference[],
  formRefs: IMaterializedReference[],
];

/**
 * Divide i riferimenti in due gruppi:
 * 1. Quelli che iniziano con $, ovvero i valori _dal contesto_
 * 2. Quelli che non iniziano con $, ovvero quello dai _valori del form_
 */
export function partitionReferences(
  references: IMaterializedReference[],
): IPartitionedReferences {
  return partition(references, ref => ref.absolutePath.startsWith('$'));
}
